<template>
  <div
    data-qa="club_price_details"
    class="d-flex flex-column gr-4"
  >
    <div class="d-flex justify-space-between">
      <span class="text-body-1 text-secondary--text">
        Цена без клуба
      </span>
      <span
        class="text-body-1 text--text"
        data-qa="club_price_details_full_price"
      >
        {{ priceList.full }}
      </span>
    </div>

    <div
      v-if="isNoCard"
      class="d-flex justify-space-between"
    >
      <div>
        <span class="text-body-1 text-secondary--text">
          Доступ к клубу
        </span>
        <div class="text-body-2 text-info--text">
          6 месяцев
        </div>
      </div>
      <span
        v-if="priceList.card"
        class="text-body-1 text--text"
        data-qa="club_price_details_card_price"
      >
        {{ priceList.card }}
      </span>
      <div
        v-else
        class="d-flex align-center gc-1"
        data-qa="club_price_details_price_card_free"
      >
        <div class="text-body-1 text--text">
          в подарок
        </div>
        <img
          src="/static/_v1/pd/icons/emoji/wrapped-present.png"
          width="20"
          height="20"
          alt="Подарок"
          data-qa="club_discount_card_free_icon"
        >
      </div>
    </div>

    <div class="d-flex justify-space-between">
      <span class="text-body-1 text-secondary--text">
        Опцион на скидку
      </span>
      <span
        class="text-body-1 text-error--text"
        data-qa="club_price_details_option_price"
      >
        {{ priceList.option }}
      </span>
    </div>

    <div class="d-flex justify-space-between">
      <span class="text-body-1 text-secondary--text">
        Приём врача
      </span>
      <span
        class="text-body-1 text-error--text"
        data-qa="club_price_details_lpu_price"
      >
        {{ priceList.lpu }}
      </span>
    </div>

    <div class="text-h6 text--text d-flex justify-space-between">
      Итого заплатите
      <span data-qa="club_price_details_total_price">
        {{ priceList.total }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance } from 'vue'
import type { Pinia } from 'pinia'
import formatPrice from 'src/functions/formatPrice'
import { useContextStore } from 'src/store'

const props = defineProps<{
  fullPrice: number
  totalPrice?: number | null
  cardPrice?: number | null
  optionPrice?: number | null
  lpuPrice?: number | null
  isNoCard: boolean
}>()

const instance = getCurrentInstance()
const pinia = (instance?.proxy as { $pinia?: Pinia } | undefined)?.$pinia
const contextCurrency = pinia ? useContextStore(pinia).context : null

const currencySymbol = computed(() => (
  contextCurrency?.currency?.symbol
  || (process.env.IS_CLIENT && window.CURRENCY_DATA?.symbol)
  || ''
))

function format(price?: number | null) {
  return formatPrice({
    price,
    currencySymbol: currencySymbol.value,
    useFreeTextForZero: true,
  })
}

const priceList = computed(() => ({
  full: format(props.fullPrice),
  total: format(props.totalPrice),
  card: props.cardPrice ? format(props.cardPrice) : '',
  option: format(props.optionPrice),
  lpu: format(props.lpuPrice),
}))
</script>
